import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-inventory-overview',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './inventory-overview.html',
  styleUrls: ['./inventory-overview.css'],
})
export class InventoryOverviewComponent {}
